<template>
  <div class="card">
    <DataTable ref="dt" :value="datas" class="p-datatable-sm" responsive-layout="scroll" removableSort showGridlines
               sortMode="single" sortField="periodo" :sortOrder="1" stripedRows :loading="loading"
               rowGroupMode="subheader" groupRowsBy="periodo" :filters="filters">
      <template #header>
        <div class="table-header flex flex-column md:flex-row md:justiify-content-between">
          <h5 class="mb-2 md:m-0 p-as-md-center">Cuenta Corriente</h5>
          <span class="p-input-icon-left m-2">
            <i class="pi pi-search" />
            <InputText v-model="filters['global'].value" placeholder="Filtrar..." />
          </span>
          <div class="ml-2">
            <Button icon="pi pi-external-link" label="Export" @click="exportCSV($event)" />
          </div>
        </div>
      </template>
      <Column field="periodo" header="Periodo" :sortable="true"></Column>
      <Column field="numero" header="Comprobante"></Column>
      <Column field="detalle" header="Detalle"></Column>
      <Column field="cuotas" header="Cuotas"></Column>
      <Column field="debe" header="Debe">
        <template #body="slotProps">
          {{formatCurrency(slotProps.data.debe)}}
        </template>
      </Column>
      <Column field="haber" header="Haber">
        <template #body="slotProps">
          {{formatCurrency(slotProps.data.haber)}}
        </template>
      </Column>
      <Column field="saldo" header="Saldo">
        <template #body="slotProps">
          {{formatCurrency(slotProps.data.saldo)}}
        </template>
      </Column>
      <template #groupheader="slotProps">
        <div>
          Periodo:
          <Tag class="ml-2" severity="info">{{slotProps.data.periodo.substring(0,4)}} - {{slotProps.data.periodo.substring(4)}}</Tag>
        </div>
      </template>
      <template #groupfooter="slotProps">
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>{{sumSaldo}}</td>
        <td style="text-align: right" class="font-bold p-pr-6">Total: ${{calculateTotal(slotProps.data)}}</td>
      </template>
    </DataTable>
  </div>
</template>

<script>
  import { ref, onMounted } from 'vue';
  import DataTable from 'primevue/datatable';
  import Column from 'primevue/column';
  import InputText from 'primevue/inputtext';
  import Button from 'primevue/button';
  import Tag from 'primevue/tag';
  import WService from '@/plugins/ws';
  import { FilterMatchMode } from 'primevue/api';

  export default {
    components: {
      DataTable, Column, InputText, Button, Tag
    },
    props: {
      idAfiliado: Number,
    },
    setup(props) {
      onMounted(() => {
        loading.value = true;
        wService.value.getMethod("Comprobantes/Viejo/" + props.idAfiliado).then(data => {
          datas.value = data;
          loading.value = false;
        }).catch(ex => {
          loading.value = false;
          console.log("Error Mounted: ", ex);
        });
      })
      const loading = ref(true);
      const dt = ref();
      const datas = ref();
      const wService = ref(new WService());
      const filters = ref({
        'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
      });

      const exportCSV = () => {
        dt.value.exportCSV();
      };

      const formatCurrency = (value) => {
        if (value)
          return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        return;
      };

      const calculateTotal = (name) => {
        let debe = 0, haber = 0;

        for (let d of datas.value) {
          if (d.periodo === name.periodo) {
            debe += parseFloat(d.debe);
            haber += parseFloat(d.haber);
          }
        }
        return debe - haber;
      };

      return {
        loading, dt, datas, filters, exportCSV, formatCurrency, calculateTotal,
      }
    }
  }
</script>